import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import {
    SearchVersionPreference,
    SearchVersionUsed,
} from 'shared/const/searchVersionPreference';
import { readSearchVersionPreferenceFromStorage } from 'shared/lib/searchVersionPreference/searchVersionPreferenceStorage';

import { SearchVersionPreferenceSchema } from '../types/SearchVersionPreferenceSchema';

const initialState: SearchVersionPreferenceSchema = {
    preference: readSearchVersionPreferenceFromStorage(),
    lastUsedVersion: null,
};

export const SearchVersionPreferenceSlice = createSlice({
    name: 'searchVersionPreference',
    initialState,
    reducers: {
        setPreference: (
            state,
            action: PayloadAction<SearchVersionPreference>,
        ) => {
            state.preference = action.payload;
        },
        setLastUsedVersion: (
            state,
            action: PayloadAction<SearchVersionUsed>,
        ) => {
            state.lastUsedVersion = action.payload;
        },
    },
});

export const { actions: searchVersionPreferenceActions } =
    SearchVersionPreferenceSlice;
export const { reducer: searchVersionPreferenceReducer } =
    SearchVersionPreferenceSlice;
